import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Grid from "@mui/material/Grid";
import { makeStyles } from "@mui/styles";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { Fab, Card, InputAdornment } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import SearchData from "../components/SearchData";
import api from "../../../components/services/api";
import useDebounce from "../../../libs/hooks/useDebounce";
import DowloadBT from "../components/dowloadBT";
import Box from "@mui/material/Box";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import DesktopDatePicker from "@mui/lab/DesktopDatePicker";
import { DataGrid } from "@mui/x-data-grid";
import { useSelector } from "react-redux";
import TextField from "@mui/material/TextField";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import SearchIcon from "@mui/icons-material/Search";
import moment from "moment";
import mime from "mime";
import { saveAs } from "file-saver";
import {
  GridToolbarContainer,
  GridToolbarExport,
  gridClasses,
} from "@mui/x-data-grid";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  // textField: {
  //   marginLeft: theme.spacing(1),
  //   marginRight: theme.spacing(1),
  //   width: 100,
  // },
  // dense: {
  //   marginTop: theme.spacing(2),
  // },
  menu: {
    width: 100,
  },
}));

export default function Quotation() {
  const classes = useStyles();
  const [dateStart, setDateStart] = useState(null);
  const [dateEnd, setDateEnd] = useState(null);
  const [key, setKey] = useState("");
  const debouncedKey = useDebounce(key, 500);
  const [checkAll, setCheckAll] = useState(true);

  const [datasf, setDatasf] = useState([]);
  const [loading, setLoading] = useState(false)

  const SearchDate = (startdate, enddate) => {
    const newData = datasf.filter((x) => {
      return (
        new Date(x.QuotationDate) >= startdate &&
        new Date(x.QuotationDate) <= enddate
      );
    });

    setDataFilter(newData);
  };
  // const [datas, setData] = useState([]);
  const [dataFilter, setDataFilter] = useState([]);
  const MenuActive = useSelector((state) => state.MenuActive.List);
  const details = [];

  if (dataFilter.length > 0) {
    dataFilter.forEach((x) => {
      details.push(...x.detail);
    });
  }

  let headerContainers = [
    ...new Set(
      details
        ?.sort((a, b) =>
          a?.ContainerTypeName?.localeCompare(b?.ContainerTypeName)
        )
        .map((x) => x?.ContainerTypeId)
    ),
  ];

  const tableHeaders = headerContainers.map((_containerTypeId) => {
    const _container = details?.find(
      (x) => x?.ContainerTypeId === _containerTypeId
    );
    if (_container) {
      return {
        field: _container?.ContainerTypeId,
        headerName: _container?.ContainerTypeName,
        width: 200,
      };
    }
  });


  // console.log(tableHeaders);
  function CustomToolbar() {
    return (
      <GridToolbarContainer className={gridClasses.toolbarContainer}>
        <GridToolbarExport
          style={{
            color: "#84BD5A",
            borderColor: "#84BD5A",
            border: "1px solid #84BD5A",
          }}
          printOptions={{ disableToolbarButton: true }}
          csvOptions={{
            fields: [
              "QuotationDate",
              "QuotationNo",
              "customer",
              "EtdCloseingDate",
              "Amount",
              "QuotationDraftNo",
            ],
            fileName: "QuotationData " + new Date() + Math.random(),
          }}
        />
      </GridToolbarContainer>
    );
  }
  /* table data */
  const columns = [
    {
      field: "QuotationDate",
      headerName: "DOC. DATE",
      width: 200,
      valueFormatter: ({ value }) => {
        return moment(value).format("DD-MM-YYYY")

      },
    },
    { field: "QuotationNo", headerName: "QT NO.", width: 200 },
    { field: "QuotationDraftNo", headerName: "Draft NO.", width: 200 },
    {
      field: "customer",
      headerName: "CustomerName",
      width: 200,
      valueGetter: (params) => `${params.value.CustomerName || ""}`,
    },

    {
      field: "Amount",
      headerName: "NET AMOUNT",
      width: 200,
      valueGetter: (params) => {
        return params
          .getValue(params.id, "detail")
          .map((item) => item.Amount)
          .reduce((prev, cur) => {
            return prev + parseInt(cur, 10);
          }, 0);
      },
    },

    // dynamic columns

    {
      field: "Status",
      headerName: "STATUS",
      width: 250,
      valueFormatter: ({ value }) =>
        value == 1
          ? "PENDING"
          : value == 2
            ? "APPROVED"
            : value == 3
              ? "DONE"
              : "REJECT",
    },
    {
      field: "ACTION",
      width: 200,
      sortable: false,
      renderCell: (params) => {
        return (
          <>
            <Link
              to={{
                pathname: `/CustomerSupport/EditQuotation/${params.id}`,
                Duplicate: 4,
              }}
            >
              <Button
                variant="contained"
                style={{
                  textTransform: "none",
                  backgroundColor: "#007BFF",
                  marginRight: 5,
                }}
              >
                <span
                  className="material-icons-outlined"
                  style={{ fontSize: 18, marginRight: 3 }}
                >
                  content_copy
                </span>
                Duplicate
              </Button>
            </Link>
            <Link
              to={{
                pathname: `/CustomerSupport/EditQuotation/${params.id}`,
              }}
            >
              <Button
                variant="contained"
                style={{ textTransform: "none", backgroundColor: "#007BFF" }}
              >
                View
              </Button>
            </Link>
          </>
        );
      },
    },
  ];

  //Floating Button
  const floating_action_style = {
    margin: 0,
    top: "auto",
    right: 20,
    bottom: 10,
    left: "auto",
    position: "fixed",
  };
  const handlesearch = () => {
    api
      .get(`api/quotation/list?startDate=${dateStart ? moment(dateStart).format('yyyy-MM-DD') : ''}&endDate=${dateEnd ? moment(dateEnd).format('yyyy-MM-DD') : ''}`)
      .then((res) => {
        setDataFilter(res?.data);
      });
  };
  const fetchQuotationList = async () => {
    try {
      const result = await api.get(`api/quotation/list?keyword=${debouncedKey}${dateStart ? '&startDate=' + moment(dateStart).format('yyyy-MM-DD') : ''}${dateEnd ? '&endDate=' + moment(dateEnd).format('yyyy-MM-DD') : ''}`);
      const _data = result?.data;
      setDatasf(_data);
      setDataFilter(_data);

      // if (_data.length > 0) {
      //   _data.forEach((c) => {
      //     // sum qty
      //     let _qty = [...new Set(c.detail.map((x) => x.ContainerTypeId))];
      //     _qty.forEach((d) => {
      //       // + นำหน้า = แปลงเป็นตัวเลข
      //       // 0 = default ก่อนจะ +
      //       c[d] = c.detail
      //         .filter((x) => x.ContainerTypeId === d)
      //         .map((x) => +x.Qty)
      //         .reduce((a, b) => a + b, 0);
      //     });
      //   });
      // }

      // // setData([..._data]);
      // setDataFilter([..._data]);
    } catch (error) {
      console.log("error => ", error);
    }
  };

  useEffect(async () => {
    await fetchQuotationList();
  }, [debouncedKey, dateStart, dateEnd]);

  const download = async () => {
    setLoading(true)
    await api.get(`api/report/quotation/download?keyword=${debouncedKey}${dateStart ? '&startDate=' + moment(dateStart).format('yyyy-MM-DD') : ''}${dateEnd ? '&endDate=' + moment(dateEnd).format('yyyy-MM-DD') : ''}`, {
      responseType: "blob",
      timeout: 30000
    })
      .then((blobFile) => {
        const blobFileRes = new File([blobFile?.data], "test.xlsx", {
          type: mime.getType(".xlsx"),

        });

        // window.open(
        //   URL.createObjectURL(blobFileRes, "test.csv"),
        //   "_blank"
        // );
        saveAs(blobFileRes, "quotation-report.xlsx");
        setLoading(false)
      }).catch((errpr) => {
        setLoading(false)})
  }
  return (
    <div>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <Card variant="outlined" style={{ padding: "20px", margin: "25px" }}>
          <h6 style={{ marginTop: "10px" }} className="textcolorgreen">
            ใบเสนอราคา
          </h6>

          <Grid container alignItems="center" spacing={1}>
            <Grid item xs>
              <Typography
                className="textcolordarkblue"
                variant="h5"
                component="h1"
              >
                Quotation
              </Typography>
            </Grid>
            <Grid item sx={{ display: "flex", flexDirection: "row" }}>
              <Typography className="textcolorBule">
                Customer Support{" "}
              </Typography>
              <Typography>
                <span>&nbsp;</span> / Quotation
              </Typography>
            </Grid>
          </Grid>

          <Grid
            //   container
            //   sx={{ justifyContent: "end" }}
            style={{
              marginTop: "10px",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <div style={{ display: "flex" }}>
              <DesktopDatePicker
                label="Date Start"
                value={dateStart}
                inputFormat="dd-MM-yyyy"
                onChange={(newValue) => {
                  setDateStart(newValue);
                }}
                renderInput={(params) => (
                  <TextField
                    size="small"
                    style={{ width: "60%" }} {...params} />
                )}
              />
              <DesktopDatePicker
                label="Date End"
                inputFormat="dd-MM-yyyy"
                value={dateEnd}
                minDate={new Date(dateStart)}
                onChange={async (newValue) => {
                  setDateEnd(newValue);
                }}
                renderInput={(params) => (
                  <TextField
                    size="small"
                    style={{ width: "60%", marginLeft: "10px" }}
                    {...params}
                  />
                )}
              />
              {/* <Button
                sx={{ marginLeft: "30px" }}
                variant="outlined"
                onClick={handlesearch}
              >
                <SearchIcon />
              </Button> */}
            </div>
            <div style={{ display: "flex" }}>
              <TextField
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                  disableUnderline: true,
                }}
                label="Search"
                onChange={(e) => setKey(e.target.value)}
                size="small"
              />
              <Button variant="outlined" disabled={loading}
                style={{ color: "#84BD5A", borderColor: "#84BD5A", marginLeft: '10px' }} onClick={() => download()}>
                <span className="material-icons-outlined">description</span>
                {loading ? 'Loading...' : 'Export'}</Button>
            </div>
          </Grid>

          <Box
            sx={{
              height: 630,
              width: "100%",
              marginTop: "10px",
              "& .Reject": {
                color: "#F53C56",
              },
              "& .Pending": {
                color: "#FFA101",
              },
              "& .Approved": {
                color: "#007BFF",
              },
              "& .Done": {
                color: "#80C340",
              },
            }}
          >
            <DataGrid
              getRowId={(r) => r.QuotationId}
              rows={dataFilter}
              columns={columns}
              pageSize={10}
              rowsPerPageOptions={[10]}
              hideFooterSelectedRowCount
              disableColumnFilter
              disableColumnMenu
              getCellClassName={(params) => {
                if (params.field === "Status") {
                  return params.row.Status == 1
                    ? "Pending"
                    : params.row.Status == 2
                      ? "Approved"
                      : params.row.Status == 3
                        ? "Done"
                        : "Reject";
                }
              }}
              // components={{
              //   Toolbar: CustomToolbar,
              // }}
            />
          </Box>
        </Card>
        {MenuActive.find((x) => x.ActionNo === "A013") && (
          <Link to="/CustomerSupport/AddQuotation">
            <Fab color="primary" style={floating_action_style} aria-label="add">
              <AddIcon />
            </Fab>
          </Link>
        )}
      </LocalizationProvider>
    </div>
  );
}
